module.exports = __webpack_public_path__ + "img/logo-black.786774e2.png";